import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import createLogger from 'vuex/dist/logger'
import moduleSetting from './modules/moduleSetting'
import frontend from './frontend/frontend'
import definedChart from './analysis/defined-chart' // 统计分析
import memoData from './memo/memo-data' // 备忘录
import emailData from './email/email-data' // 邮件
import custom from './custom/custom' // 自定义
import taskCustom from './task_custom/task-custom' // 任务自定义
import webformCustom from './webform_custom/webform-custom' // 任务自定义
import projectData from './project/project' // 项目
import commonFieldsTempalte from './common_fields_tempalte/common-fields-tempalte' // 项目
import commodity from './control/commodity' // 中央控制台 - 功能清单
import salary from './salary/salary' // 薪酬
import workbench from './workbench/workbench' // 门户
import okr from './OKR/okr' // okr
import target from './target/target' // 目标管理
import performance from './performance/performance' // 门户
import org from './org/org' // 组织职级
import staff from './staff/staff' // 员工管理
import attendance from './attendance/attendance' // 考勤管理
import talent from './talent/talent' // 人才管理
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const VUEX_PERSIST_KEY = 'user-info-vuex'
const VUEX_CRYPTO_KEY = 'teamface2019team'

const encryptPersistState = data => {
  const CryptoJS = window.CryptoJS
  if (!CryptoJS) return JSON.stringify(data)
  const key = CryptoJS.enc.Utf8.parse(VUEX_CRYPTO_KEY)
  const src = CryptoJS.enc.Utf8.parse(JSON.stringify(data))
  return CryptoJS.AES.encrypt(src, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

const decryptPersistState = content => {
  if (!content) return {}
  const CryptoJS = window.CryptoJS
  try {
    if (!CryptoJS) return JSON.parse(content)
    const key = CryptoJS.enc.Utf8.parse(VUEX_CRYPTO_KEY)
    const decoded = CryptoJS.AES.decrypt(content, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8)
    return decoded ? JSON.parse(decoded) : {}
  } catch (e) {
    return {}
  }
}

const plugins = [
  createPersistedState({
    key: VUEX_PERSIST_KEY,
    paths: ['frontend.userInfo'],
    getState: key => {
      return decryptPersistState(localStorage.getItem(key))
    },
    setState: (key, state) => {
      localStorage.setItem(key, encryptPersistState(state))
    }
  }),
  ...(debug ? [createLogger()] : [])
]
export default new Vuex.Store({
  actions,
  getters,
  mutations,
  strict: debug,
  plugins,
  modules: {
    frontend,
    moduleSetting,
    definedChart,
    memoData,
    emailData,
    custom,
    taskCustom,
    webformCustom,
    projectData,
    commonFieldsTempalte,
    commodity,
    salary,
    workbench,
    performance,
    okr,
    target,
    org,
    attendance,
    staff,
    talent
  }
})
